import { styled } from '@ori-ui/mui';
import { TooltipContainer as PbsTooltip } from '@ori/personal-beauty-store';
import type { FC } from 'react';
import { useCallback } from 'react';

import { useToggleMenu } from '../../hooks';
import { BurgerMenuIcon } from './BurgerMenuIcon';

const pbsTooltipOffset = {
  x: -10,
  y: -40,
};

const BurgerMenuToggleRoot = styled('div')({
  position: 'relative',
});

const StyledPbsTooltip = styled(PbsTooltip)({
  position: 'absolute',
  top: `calc(100% - ${pbsTooltipOffset.y}px)`,
  left: pbsTooltipOffset.x,
});

export const BurgerMenuToggle: FC = () => {
  const [, toggleMenu] = useToggleMenu();

  const onPbsTooltipClick = useCallback(() => {
    toggleMenu();
  }, [toggleMenu]);

  return (
    <BurgerMenuToggleRoot>
      <BurgerMenuIcon />
      <StyledPbsTooltip onClick={onPbsTooltipClick} />
    </BurgerMenuToggleRoot>
  );
};
